export const EAM_ROUTE = "/entra-mfa";
export const EAM_APP_NAME = "Entra MFA";

export interface ShellConfig {
  appId: "portal" | "eam";
  appName: string;
  icon: "portal" | "eam";
  /** Extra (restricted) apps to show in the app menu. */
  extraApps: Array<"eam">;
  /** API Docs / About Shield links belong to the portal, not to EAM. */
  showPortalNav: boolean;
  /** An EAM admin's direct link to the other page; null for everyone else. */
  pageLink: { label: string; href: string } | null;
}

const API_KEYS_LINK = { label: "API Keys", href: "/" };
const EAM_LINK = { label: EAM_APP_NAME, href: EAM_ROUTE };

/** Which top-bar identity to show for this route and user. */
export function shellConfig(
  pathname: string,
  user: { can_manage_eam?: boolean } | null | undefined,
  portalAppName: string,
): ShellConfig {
  const canEam = Boolean(user?.can_manage_eam);
  const onEam = canEam && (pathname === EAM_ROUTE || pathname.startsWith(`${EAM_ROUTE}/`));
  return {
    appId: onEam ? "eam" : "portal",
    appName: onEam ? EAM_APP_NAME : portalAppName,
    icon: onEam ? "eam" : "portal",
    extraApps: canEam ? ["eam"] : [],
    showPortalNav: !onEam,
    pageLink: !canEam ? null : onEam ? API_KEYS_LINK : EAM_LINK,
  };
}
